import surfer from "../../../../posts/first-week-as-web3-dev/surfer.jpeg";
import * as React from 'react';
export default {
  surfer,
  React
};